import type { Requests } from "../common/request.common";
import type { AuditSubscriptionResponseTypes } from "../common/response.common";
import { post, postEmpty } from "./common";

export const auditSubscription = {
    record(data: typeof Requests.AuditSubscription.Record.Input) {
        return post<typeof data, AuditSubscriptionResponseTypes.Record>(
            `/audit-subscription/record`,
            data,
        );
    },
    selectRecord(data: typeof Requests.AuditSubscription.SelectRecord.Input) {
        return post<typeof data, AuditSubscriptionResponseTypes.SelectRecord>(
            `/audit-subscription/select-record`,
            data,
        );
    },
    selectToggle(id: string) {
        return postEmpty<AuditSubscriptionResponseTypes.SelectToggle>(
            `/audit-subscription/select-toggle/${id}`,
        );
    },
};
